export const GET_EVENTS_LIST = 'GET_EVENTS_LIST';
export const GET_EVENTS_LIST_SUCCESS = 'GET_EVENTS_LIST_SUCCESS';
export const GET_EVENTS_LIST_ERROR = 'GET_EVENTS_LIST_ERROR';
export const GET_EVENT_VIEW = 'GET_EVENT_VIEW';
export const EVENT_VIEWED = 'EVENT_VIEWED';
